import { useSettingsCopies } from "@/context/StringsProvider";
import { createTranslationFunction } from "@/utils/common.helpers";
import { useMemo } from "react";

export function useClientTranslations() {
  const {
    settingsCopies: strings,
    currentLanguage,
    setCurrentLang,
  } = useSettingsCopies();

  const t = useMemo(
    () => createTranslationFunction(strings || {}, currentLanguage),
    [strings, currentLanguage],
  );

  return { t, currentLanguage, setCurrentLang };
}
